import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle<any>`
    .address-selector-dropdown .ant-select-item-option-content {
        white-space: normal;
        line-height: 1.3;
    }

    thead .ant-table-cell {
        border-bottom: 3px solid #0000001a !important;
    }

    tbody {
        tr:nth-child(2n) td {
            background-color: ${({ theme }) => theme.tableSecondRowColor};
        }
    }

    .ant-btn-link {
        text-decoration: underline;
    }

    .quality-mark-wide img {
        transform: scale(1.35);
    }

    .ant-btn {
        box-shadow: none;
    }

    .ant-modal-content {
        border-radius: 8px !important;
    }
    
    .ant-table-row {
        .ant-table-cell {
            padding: 8px 12px !important;
        }
    }

    //steps {
    .ant-steps-item-finish .ant-steps-item-icon {
        background-color: ${({ theme }) => theme.colorPrimary} !important;
        border-color: ${({ theme }) => theme.colorPrimary} !important;
        svg {
            color: ${({ theme }) => theme.white} !important;
        }
    }

  .ant-steps .ant-steps-item-wait .ant-steps-item-icon {
    background-color: transparent !important;
    border-color: ${({ theme }) => theme.black} !important;
  }
  
  .ant-table-content {
      overflow: auto;
  }
    .ant-steps .ant-steps-item-wait .ant-steps-item-icon {
        background-color: transparent;
        border-color: ${({ theme }) => theme.black} !important;

    }
    
    .ant-drawer-footer {
        background-color: ${({ theme }) => theme.filterBackground};
    }

    #cart-drawer{
        .ant-drawer-body{
            padding-top: 0;
        }
    }

    #max-amount-reached-tooltip {
        font-size: 14px;
        text-align: center;
        background-color: ${({ theme }) => theme.brand01};
    }

    #delivery-drawer{
        .ant-drawer-body{
            padding: 0;
        }
        .ant-drawer-header{
            .ant-drawer-header-title{
                flex-direction: row-reverse;
            }
        }
    }

    &.custom-modal-wrap {
        z-index: 1001 !important;
    }

    #app-root.no-scroll {
        overflow: hidden;
        position: fixed;
        width: 100%;
    }
    
    .delete-button {
        color: ${({ theme }) => theme.minus};
        border-color: ${({ theme }) => theme.minus};
    }
    
    .ant-tooltip {
      .ant-tooltip-inner {
        background-color: ${({ theme }) => theme.white} !important;
        color: ${({ theme }) => theme.black} !important;
        padding-left: 10px !important;
        padding-right: 10px !important;
      }

      .ant-tooltip-arrow {
        &:before {
          background: white !important;
        }
      }

      &.subtle-tooltip {
        .ant-tooltip-inner {
          background-color: rgba(255, 255, 255, 0.85) !important;
          color: ${({ theme }) => theme.black} !important;
          font-size: 12px;
          line-height: 16px;
          min-height: auto;
          padding-top: 4px !important;
          padding-bottom: 4px !important;
          border-radius: 10px;
        }

        .ant-tooltip-arrow {
          display: none;
        }
      }
    }
`;
